import { connect } from 'react-redux';

import ChatIcon from 'presentation/components/icons/ChatIcon';
import { getMinimizedChatButton } from 'app/modules';

export const mapStateToProps = (state, props) => {
  return {
    ...props,
    title: getMinimizedChatButton(state).title,
  };
};

const ChatIconContainer = connect(mapStateToProps)(ChatIcon);

export default ChatIconContainer;
